import llm from './llm_client'
import { Message } from './backend'
import { get } from './preferences'

export async function getModels() {
    const llmProvider = await get("llmProvider")
    const key = await get(llmProvider + 'ApiKey')
    return await llm.getModels(llmProvider, key)
}

export async function getResponse(chat_id: string, messages: Message[]) {
    const llmProvider = await get("llmProvider")
    const key = await get(llmProvider + 'ApiKey')
    const model = await get(llmProvider + 'Model')

    return await llm.getResponse(llmProvider, key, model, chat_id, messages)
}

export async function speechGetResponse(chat_id: string, voice: File) {
    const sttProvider = await get("sttProvider")
    const key = await get(sttProvider + 'ApiKey')
    const model = await get(sttProvider + 'Model')

    return await llm.speechGetResponse(sttProvider, key, model, chat_id, voice)
}